// pages/Invoice.tsx
import React, { useState, useEffect } from "react";
import SEOHead from "../components/shared/SEOHead";
import { getPageSEO } from "../utils/seoConfig";
import axios from "axios";
import Navbar from "../components/shared/Navbar";

// Updated interface to match the API response structure
interface InvoiceItem {
  description: string;
  quantity: number;
  unitPrice: number;
}

interface HistoryItem {
  _id: string;
  UserID: string;
  FormID: string;
  PresentationURL: string;
  pptName: string;
  currentTime: string;
  paymentStatus: number;
  order_id: string;
  ppt_type: string;
  __v: number;
  exportstatus?: boolean;
  invoiceURL?: string;
}

const Invoice: React.FC = () => {
  const [invoices, setInvoices] = useState<HistoryItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  
  const authToken = sessionStorage.getItem('authToken');
  const orgId = sessionStorage.getItem('orgId');
  const userEmail = sessionStorage.getItem('userEmail');

  useEffect(() => {
    const fetchInvoices = async () => {
      if (!authToken || !userEmail) {
        setError("Authentication or user information missing");
        setLoading(false);
        return;
      }      try {
        // Using the provided API endpoint with user email from sessionStorage
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/slidedisplay/history/${userEmail}?page=1&limit=10`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        
        // Setting the data from the API response
        console.log("API response:", response.data);
          // Check if response.data.data exists and is an array (based on the API structure you shared)
        if (response.data && response.data.data && Array.isArray(response.data.data)) {
          // Filter to show only invoices that have an invoiceURL and are paid (paymentStatus === 1)
          const filteredInvoices = response.data.data.filter(
            (invoice: HistoryItem) => invoice.invoiceURL && invoice.paymentStatus === 1
          );
          setInvoices(filteredInvoices);
        } else {
          setInvoices([]);
        }
        
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch invoices:", err);
        setError("Failed to load invoices. Please try again later.");
        setLoading(false);
      }
    };
    
    fetchInvoices();
  }, [authToken, userEmail]);

  // Function to format date
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <>
      <SEOHead seo={getPageSEO("invoice")} />
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="container mx-auto px-4 py-6">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">Invoices</h1>
        
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
          </div>        ) : error ? (
          <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-6">
            <p>{error}</p>
          </div>        ) : !invoices || invoices.length === 0 ? (
          <div className="bg-white rounded-lg shadow-md p-6 text-center">
            <h2 className="text-xl text-gray-700 mb-2">No Invoices Found</h2>
            <p className="text-gray-600">You don't have any invoices at the moment.</p>
          </div>
        ) : (
          <div className="grid gap-6">
            {Array.isArray(invoices) && invoices.map((invoice) => (
              <div 
                key={invoice._id} 
                className="bg-white rounded-lg shadow-md overflow-hidden"
              >
                <div className="p-6">
                  <div className="flex justify-between items-start mb-6">
                    <div>                      <h2 className="text-2xl font-bold text-gray-800">
                        {invoice.pptName || "Presentation"}
                      </h2>
                      <p className="text-gray-600">
                        Created: {formatDate(invoice.currentTime)}
                      </p>
                    </div>
                      <div className="text-right">
                      {/* Removed payment status tag as requested */}
                    </div>
                  </div>
                  
                  <div className="mt-6 flex justify-end space-x-4">                    {invoice.invoiceURL && (
                      <a 
                        href={invoice.invoiceURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                      >
                        View Invoice
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
    </>
  );
};

export default Invoice;
